import React, { Component } from 'react'

import _ from 'lodash'

import Autocomplete from 'react-autocomplete'

import ChoiceField from './ChoiceField'


class AutocompleteInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            typedValue: props.value,
            lastPropsValue: props.value,
        };
        this._debouncers = {};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.lastPropsValue !== this.props.value)
            this.setState({
                "typedValue": this.props.value,
                "lastPropsValue": this.props.value,
            });
    }

    sendOnChange = (v) => {
        const delay = this.props.delay || 1500;
        if (!this._debouncers[delay])
            this._debouncers[delay] = _.debounce(
                (x) => {
                    if (this.props.onValueChange)
                        this.props.onValueChange(x);
                },
                delay,
            );
        const val = v
        this._debouncers[delay](val);
    };

    onChangeHandler = (v) => {
        if (typeof (v) == "object") {
            v = v.target.value
        }
        this.setState({ typedValue: v });
        // e.persist();
        this.sendOnChange(v);
    };

    render() {
        const { value, items, placeholder, onValueChange, onSelect } = this.props;

        return (
            <div className={"autocomplete-input"}>
                <Autocomplete
                    items={items ? items : []}
                    getItemValue={(item) => (item)}
                    renderItem={(item, isHighlighted) =>
                        <div
                            style={{ background: isHighlighted ? 'lightgray' : 'white' }}
                            key={item}
                        >
                            {item}
                        </div>
                    }
                    shouldItemRender={(a, b) => {
                        if (!b && items.length > 20)
                            return false;
                        a = a.toLowerCase();
                        b = b.toLowerCase();
                        const idx = a.indexOf(b);
                        if (idx === 0 /*|| (idx > 0 && b.length > 3)*/)
                            return true;
                    }}
                    value={this.state.typedValue}
                    onChange={this.onChangeHandler}
                    onSelect={(val) => {
                        this.onChangeHandler(val)
                        if (onValueChange)
                            onValueChange(val);
                    }}
                    onMenuVisibilityChange={(isOpen) => {
                        if (!isOpen && onSelect)
                            onSelect(value);
                    }}
                    inputProps={{
                        placeholder: placeholder ? placeholder : "Suchbegriff"
                    }}
                />
            </div>
        );
    }
}

export default AutocompleteInput;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/AutocompleteInput.js